export const normalizeZoneAgencyId = (value) => String(value ?? '').trim();

export const getZoneAgencyOptions = (rows, currentAgencyId) =>
  [
    ...new Set([
      ...rows.map((row) => normalizeZoneAgencyId(row.AgencyID)),
      normalizeZoneAgencyId(currentAgencyId),
    ]),
  ]
    .filter(Boolean)
    .map((value) => ({ value, label: value }));

export const formatCodeZones = (values) => ({
  ZoneCode: values.ZoneCode,
  Description: values.Description || values.Code,
  AgencyID: values.AgencyID,
  IsDefault: values.IsDefault,
  IsActive: values.IsActive,
  IsDeleted: false,
  Flags: values.Flags || null,
  Category: values.Category,
  Code2: values.Code2,
  Code3: values.Code3,
  Code4: values.Code4,
  Description2: values.Description2 || values.Code2,
  Description3: values.Description3 || values.Code3,
  Description4: values.Description4 || values.Code4,
  Zone1: values.Zone1,
  Zone2: values.Zone2,
  Zone3: values.Zone3,
  Zone4: values.Zone4,
  Zone5: values.Zone5,
});
